import { render, staticRenderFns } from "./report-detail.vue?vue&type=template&id=6dd368de&scoped=true&"
import script from "./report-detail.vue?vue&type=script&lang=js&"
export * from "./report-detail.vue?vue&type=script&lang=js&"
import style0 from "./report-detail.vue?vue&type=style&index=0&id=6dd368de&lang=scss&scoped=true&"
import style1 from "./report-detail.vue?vue&type=style&index=1&id=6dd368de&scoped=true&lang=scss&media=print&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd368de",
  null
  
)

export default component.exports